import * as types from '../actions/actionTypes'

export default function getData1Reducer(state = [], action) {
    switch (action.type) {
        case types.live.GET_HOMELINE_SUCCESS:
            return { ...state, liveHomeLine: action.data }

        // case types.live.GET_BACKLINE_SUCCESS:
        //     return { ...state, liveBackLine: action.data }

        default:
            return state;
    }
}

